import PropTypes, {
  arrayOf, bool, func, shape, string
} from 'prop-types';

export const SSRStore = '8119';

export const MIN_DESIRED_TAB_ITEMS = 3;

export const getTypeTabTitle = (type, brandName, isAccordionTitle) => {
  switch (type) {
  case 'collection': {
    return isAccordionTitle && brandName ? `Shop This Collection from ${brandName}` : 'More from This Brand';
  }
  case 'accessories': {
    return isAccordionTitle ? 'You Might Also Need' : 'Shop Accessories';
  }
  default: {
    return type;
  }
  }
};

export const queryOptionsHandler = ({ options, dataSource }) => {
  if (dataSource === 'catalog') {
    return {
      ...options,
      fetchPolicy: 'cache-first'
    };
  }
  return options;
};

export const shouldSkipQuery = ({ loadedStoreId, storeId, isClientResolved, skip }) => {
  const defaultStoreId = loadedStoreId || SSRStore;
  const isResolved = isClientResolved({ queryName: 'dynamicRecs' });
  const clientStoreChanged = (defaultStoreId !== SSRStore && !isResolved)
    || (defaultStoreId === SSRStore && storeId !== SSRStore);

  return clientStoreChanged || skip;
};

export const getDefaultQueryVariables = ({ storeId, storeZip, membershipInformation }) => {
  return {
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership || null,
    storeId: storeId || SSRStore,
    zipCode: storeZip,
  };
};

export const ItemRelatedGroupsPropType = {
  accordion: PropTypes.bool,
  enableFulfillment: PropTypes.bool,
  itemId: PropTypes.string,
  maxItems: PropTypes.number,
  showMobileCardTabs: PropTypes.bool
};

export const ItemRelatedGroupsDefaultProps = {
  accordion: false,
  enableFulfillment: false,
  itemId: null,
  maxItems: 8,
  showMobileCardTabs: false
};

export const multipleAccordionIRGPropType = {
  enableFulfillment: bool,
  onClickCategory: func,
  onClickNext: func,
  showMobileCardTabs: bool,
  tabs: arrayOf(shape({
    name: string
  })).isRequired,
};

const NOOP = () => {
};

export const multipleAccordionIRGDefaultProps = {
  enableFulfillment: false,
  onClickCategory: NOOP,
  onClickNext: NOOP,
  showMobileCardTabs: false
};
